export default {
  ".editorconfig": "i-vscode-icons-file-type-editorconfig",
  ".env": "i-vscode-icons-file-type-dotenv",
  ".env.example": "i-vscode-icons-file-type-dotenv",
  ".eslintignore": "i-vscode-icons-file-type-eslint",
  ".eslintrc": "i-vscode-icons-file-type-eslint",
  ".eslintrc.cjs": "i-vscode-icons-file-type-eslint",
  ".gitignore": "i-vscode-icons-file-type-git",
  ".npmrc": "i-vscode-icons-file-type-npm",
  ".nuxtignore": "i-vscode-icons-file-type-nuxt",
  ".nuxtrc": "i-vscode-icons-file-type-nuxt",
  ".vscode/settings.json": "i-vscode-icons-file-type-vscode",
  "asm": "i-vscode-icons-file-type-assembly",
  "bicep": "i-vscode-icons-file-type-bicep",
  "bicepparam": "i-vscode-icons-file-type-bicep",
  "bun": "i-vscode-icons-file-type-bun",
  "cjs": "i-vscode-icons-file-type-js",
  "cs": "i-vscode-icons-file-type-csharp",
  "dart": "i-vscode-icons-file-type-dartlang",
  "deno": "i-vscode-icons-file-type-deno",
  "erl": "i-vscode-icons-file-type-erlang",
  "eslint.config.cjs": "i-vscode-icons-file-type-eslint",
  "eslint.config.js": "i-vscode-icons-file-type-eslint",
  "eslint.config.mjs": "i-vscode-icons-file-type-eslint",
  "exs": "i-vscode-icons-file-type-elixir",
  "f": "i-vscode-icons-file-type-fortran",
  "fs": "i-vscode-icons-file-type-fsharp",
  "gleam": "i-vscode-icons-file-type-gleam",
  "go": "i-vscode-icons-file-type-go",
  "h": "i-vscode-icons-file-type-cppheader",
  "hs": "i-vscode-icons-file-type-haskell",
  "ico": "i-vscode-icons-file-type-favicon",
  "ino": "i-vscode-icons-file-type-arduino",
  "jl": "i-vscode-icons-file-type-julia",
  "js": "i-vscode-icons-file-type-js",
  "jsx": "i-vscode-icons-file-type-js",
  "kt": "i-vscode-icons-file-type-kotlin",
  "lsp": "i-vscode-icons-file-type-lisp",
  "md": "i-vscode-icons-file-type-markdown",
  "mjs": "i-vscode-icons-file-type-js",
  "npm": "i-vscode-icons-file-type-npm",
  "npx": "i-vscode-icons-file-type-npm",
  "nuxt": "i-vscode-icons-file-type-nuxt",
  "nuxt.config.js": "i-vscode-icons-file-type-nuxt",
  "nuxt.config.ts": "i-vscode-icons-file-type-nuxt",
  "nuxt.schema.ts": "i-vscode-icons-file-type-nuxt",
  "package.json": "i-vscode-icons-file-type-node",
  "pl": "i-vscode-icons-file-type-perl",
  "pnpm": "i-vscode-icons-file-type-pnpm",
  "ps1": "i-vscode-icons-file-type-powershell",
  "psd1": "i-vscode-icons-file-type-powershell",
  "psm1": "i-vscode-icons-file-type-powershell",
  "py": "i-vscode-icons-file-type-python",
  "rb": "i-vscode-icons-file-type-ruby",
  "rs": "i-vscode-icons-file-type-rust",
  "sbt": "i-vscode-icons-file-type-scala",
  "tailwind.config.js": "i-vscode-icons-file-type-tailwind",
  "tailwind.config.ts": "i-vscode-icons-file-type-tailwind",
  "terminal": "i-lucide-terminal",
  "ts": "i-vscode-icons-file-type-typescript",
  "tsconfig.json": "i-vscode-icons-file-type-tsconfig",
  "tsx": "i-vscode-icons-file-type-typescript",
  "vue": "i-vscode-icons-file-type-vue",
  "yarn": "i-vscode-icons-file-type-yarn",
  "yarn.lock": "i-vscode-icons-file-type-yarn",
  "yml": "i-vscode-icons-file-type-yaml"
}